if (!customElements.get('homepage-background')) {
    customElements.define(
      'homepage-background',
      class HomepageBackground extends HTMLElement {
        constructor() {
            super();

            this.backgrounds = document.querySelectorAll('.template--index [data-bg-color]')
            let root = document.documentElement;

            function callback(entries) {
                if (entries[0].isIntersecting) {
                    let { bgColor } = entries[0].target.dataset
                    root.style.setProperty('--base-bg', bgColor);
                }
             }
    
             var options = {
                root: null,
                threshold: [0.25, 1]
             }
             
             var observe = new IntersectionObserver(callback, options);
             
             // observe each div element
             this.backgrounds.forEach((background) => {
                observe.observe(background)
             })
        }

      }
    );
  }